import Vue from 'vue';

const preventDefaultForLink = event => {
  if (event && !event.ctrlKey && !event.metaKey) {
    event.preventDefault();
  }
};

const ctrlOrCommandPressed = event => {
  return event && (event.ctrlKey || event.metaKey);
};

const navigateOrNewTab = (url, router, event) => {
  if (ctrlOrCommandPressed(event)) {
    window.open(url, '_blank');
  } else {
    router.push(url);
  }
};

const helpers = {
  preventDefaultForLink,
  ctrlOrCommandPressed,
  navigateOrNewTab,
};

export default {
  install: () => {
    Vue.prototype.$helpers = helpers;
    Vue.$helpers = helpers;
  },
};
